// extracted by mini-css-extract-plugin
export default {"withBorder":"ff-logo_withBorder__e99V7"};